import React, {Component} from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './Home';
import About from './About';
import NotFound from './NotFound';
import DeletePhotosExceptFavorites from './DeletePhotosExceptFavorites';
import PrivacyPolicy from './PrivacyPolicy';
import classnames from 'classnames';
import {
	BrowserRouter as Router,
	Route,
	Link
} from 'react-router-dom'

class App extends Component {
	render() {
    	const {className, ...props} = this.props;
    	return (
	    	<Router>
			    <div className={classnames('App', className)} {...props}>
			    	<div className="App-header">
	          			<h2><a href="/" style={{textDecoration:'none', color:'white'}}>Metrobyte</a></h2>
	        		</div>
			    	<Route exact path="/" component={Home}/>
			    	<Route path="/about" component={About}/>
			    	<Route path="/deletephotosexceptfavorites" component={DeletePhotosExceptFavorites}/>
			    	<Route path="/privacypolicy" component={PrivacyPolicy}/>
			    	<Route path="/notfound" component={NotFound}/>
			    </div>
			</Router>
    	);
  	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js